<div class="hub-input">
    <div class="eu-display_flex eu-align-items_baseline" style="gap: 0.5rem">
        <label
            *ngIf="!hideLabel"
            [for]="id"
            class="emd-label"
            [ngClass]="{
                _state_error: control.invalid && control.touched && control.dirty,
            }"
            >{{ label }}<i *ngIf="isRequired"> *</i></label
        >
        <span *ngIf="tipText" class="emd-tooltip _position_right word-break" [attr.data-tooltip]="tipText">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
        </span>
    </div>
    <div *ngIf="!fieldConfigs.ngMask">
        <input
            #formInput
            [id]="id"
            class="emd-input"
            [type]="fieldType"
            [placeholder]="fieldConfigs.placeholder"
            [ngClass]="{
                _state_error: control.invalid && (control.touched || control.dirty),
            }"
            [disabled]="isReadOnly"
            [(ngModel)]="value"
            (input)="onChanged(value)"
            (blur)="onTouched()"
            [ngStyle]="customInputStyle"
            [attr.data-cy]="controlName"
        />
    </div>
    <div *ngIf="fieldConfigs.ngMask">
        <input
            #formInput
            [id]="id"
            class="emd-input"
            [type]="fieldType"
            [placeholder]="fieldConfigs.placeholder"
            [mask]="fieldConfigs.ngMask"
            [ngClass]="{
                _state_error: control.invalid && (control.touched || control.dirty),
            }"
            [disabled]="isReadOnly"
            [(ngModel)]="value"
            (input)="onChanged(value)"
            (blur)="onTouched()"
            [ngStyle]="customInputStyle"
            [attr.data-cy]="controlName"
        />
    </div>
    <app-control-error [standAloneForm]="standAloneForm" [control]="control" [label]="label"></app-control-error>
</div>
